module.exports = __webpack_public_path__ + "static/media/toddler.46f64c12.jpg";